import React from 'react';
import BullhornOutlineIcon from 'mdi-react/BullhornOutlineIcon';
import GaugeIcon from 'mdi-react/GaugeIcon';
import WrenchOutlineIcon from 'mdi-react/WrenchOutlineIcon';
import ChartLineIcon from 'mdi-react/ChartLineIcon';
import {
  Users as UsersIcon,
  HelpCircle as HelpIcon,
  Key as KeyIcon,
  File as FileIcon,
  Search as SearcIcon,
  Layout as WidgetIcon,
} from 'react-feather';
import SwapHorizontalCircleOutlineIcon from 'mdi-react/SwapHorizontalCircleOutlineIcon';
import BriefcaseOutlineIcon from 'mdi-react/BriefcaseOutlineIcon';

const iconProps = {
  size: 20,
  className: 'mr-1',
};

export const menuItems = (user) => [
  {
    label: 'dashboard',
    pathname: '/advertisers',
    icon: <GaugeIcon {...iconProps} />,
  },
  ...(user.pro
    ? [
        {
          label: 'marketplace.title',
          icon: <SearcIcon {...iconProps} />,
          children: [
            {
              label: 'marketplace.affiliates',
              pathname: '/advertisers/marketplace',
            },
            {
              label: 'marketplace.invites',
              pathname: '/advertisers/marketplace/invites',
            },
          ],
        },
      ]
    : []),
  {
    label: 'affiliates.partnerships',
    icon: <UsersIcon {...iconProps} />,
    children: [
      {
        label: 'affiliates.affiliates',
        pathname: '/advertisers/affiliates',
      },
    ],
  },
  {
    label: 'inventories.inventories',
    icon: <BriefcaseOutlineIcon {...iconProps} />,
    children: [
      {
        label: 'inventories.offers',
        pathname: '/advertisers/offers',
      },
      {
        label: 'inventories.imageCreatives',
        pathname: '/advertisers/banners',
      },
      {
        label: 'inventories.textCreatives',
        pathname: '/advertisers/promo-deals',
      },
      ...(user.hasProductApi
        ? [
            {
              label: 'inventories.products',
              pathname: '/advertisers/products',
            },
          ]
        : []),
    ],
  },
  {
    label: 'transactions.transactions',
    icon: <SwapHorizontalCircleOutlineIcon {...iconProps} />,
    checkActive: (currentPathname) => {
      return currentPathname === '/advertisers/transactions/pending/by-offer/[offerId]';
    },
    children: [
      {
        label: 'transactions.clicks',
        pathname: '/advertisers/transactions/clicks',
      },
      {
        label: 'transactions.captured',
        pathname: '/advertisers/transactions/captured',
      },
      {
        label: 'transactions.published',
        pathname: '/advertisers/transactions/published',
      },
      {
        label: 'transactions.confirmed',
        pathname: '/advertisers/transactions/confirmed',
      },
      {
        label: 'transactions.pending',
        pathname: '/advertisers/transactions/pending',
        checkActive: (currentPathname) =>
          currentPathname === '/advertisers/transactions/pending/by-offer/[offerId]',
      },
      {
        label: 'transactions.orderInquiry',
        pathname: '/advertisers/order-inquiries',
      },
      {
        label: 'transactions.upload',
        pathname: '/advertisers/transactions/upload',
      },
    ],
  },
  {
    label: 'reports.reports',
    icon: <ChartLineIcon {...iconProps} />,
    children: [
      {
        label: 'reports.offerPerformance',
        pathname: '/advertisers/reports/offer-stats',
      },
      {
        label: 'reports.affiliatePerformance',
        pathname: '/advertisers/reports/affiliate-stats',
      },
      {
        label: 'reports.imageCreativePerformance',
        pathname: '/advertisers/reports/banner-stats',
      },
      {
        label: 'reports.textCreativePerformance',
        pathname: '/advertisers/reports/promo-deal-stats',
      },
      {
        label: 'reports.conversion',
        pathname: '/advertisers/reports/conversion-stats',
      },
      {
        label: 'reports.finalizedConversion',
        pathname: '/advertisers/reports/final-stats',
      },
      {
        label: 'reports.affiliation',
        pathname: '/advertisers/reports/affiliation',
      },
    ],
  },
  {
    label: 'data.managements',
    icon: <WrenchOutlineIcon {...iconProps} />,
    children: [
      {
        label: 'data.productApis',
        pathname: '/advertisers/product-apis',
      },
      {
        label: 'data.downloads',
        pathname: '/advertisers/downloads',
      },
      {
        label: 'data.uploads',
        pathname: '/advertisers/uploads',
      },
    ],
  },
  {
    label: 'documentation.documentation',
    icon: <FileIcon {...iconProps} />,
    children: [
      {
        label: 'documentation.tracking',
        pathname: '/advertisers/documentation/tracking',
      },
      {
        label: 'documentation.api',
        pathname: '/advertisers/documentation/api',
      },
    ],
  },
  {
    label: 'widgets.affiliateSignupLink',
    icon: <WidgetIcon {...iconProps} />,
    pathname: '/advertisers/widgets/affiliate-signup-link',
  },
  {
    label: 'announcements',
    pathname: '/advertisers/announcements?role=network',
    icon: <BullhornOutlineIcon {...iconProps} />,
  },
  {
    label: 'apiKeys',
    pathname: '/advertisers/api-keys',
    icon: <KeyIcon {...iconProps} />,
  },
  {
    label: 'faq',
    pathname: '/advertisers/faqs',
    icon: <HelpIcon {...iconProps} />,
  },
];
